import React from 'react'

function MemberMealsList() {
  return (
    <div>
      <button className='bg-red-500'>Reqest meal</button>
      this is upur mals
    </div>
  )
}

export default MemberMealsList
